import axios from 'axios'
import ApiConfig from '../../../../../_metronic/util/ApiConfig'

const API_HOST = ApiConfig.getApiHost()

const axiosInstance = axios.create({
  baseURL: API_HOST,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default axiosInstance
